import React, {useCallback} from "react";
import {useDropzone} from 'react-dropzone';

import {ApolloMessage, CustomizedSnackbars} from "./Apollo_Mesasge";
import {apollo_useStyles} from "./Apollo_styles";

export const ApolloFileSelect: React.FC<{
  accept?: string,
  /** Maximum file size (in MByte) */
  maxSize?: number,
  isMultiple?: boolean,
  setBinary?: any,
  setFiles: any, 
}> = ({
  accept,
  maxSize,
  isMultiple,
  setBinary,
  setFiles,
}) => {
  const classes = apollo_useStyles();
  const reader = new FileReader();
  const {data, setmsg} = React.useContext(ApolloMessage);

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles.length === 0) {
      setFiles("");
      return;
    }
    if (!checkMaxSize(acceptedFiles[0].size)) {
      setFiles("");
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `${maxSize}MB 以下のファイルを設定してください。`,
        }
      });
      return;
    }
    setFiles(acceptedFiles);

    reader.onload = () => {
      if (setBinary) {
        setBinary(reader.result as string);
      }
    }
    reader.readAsDataURL(acceptedFiles[0]);
  }, []);

  const checkMaxSize = (size: number | undefined) => {
    if (!size) {
      return true;
    }
    if (maxSize && maxSize != 0) {
      if (size > 1024*1024*maxSize) {
        return false;
      }
    }
    return true;
  }

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    accept: accept,
    // maxSize: 1024*1024*30,
    multiple: isMultiple,
    onDrop,
  });

  // @ts-ignore
  const files = acceptedFiles.map(file => {
    const isOK = checkMaxSize(file.size)
    return (
      isOK ? <li key="file1">{file.name}</li> : undefined
    );
  });

  return (
    <React.Fragment>
      <CustomizedSnackbars/>
      <section
        className="container">
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <div className={classes.droparea}>
            <p className={classes.p}>
              ここにファイルをドラッグ＆ドロップ
              <br/>
              もしくは、クリックして選択
            </p>
          </div>
        </div>
        <ul id="file1">
          {files}
        </ul>
      </section>
    </React.Fragment>
  );
}
export default ApolloFileSelect;
